export const skeletonColor = Styles.color.grey.five;
export const skeletonSecondaryColor = Styles.color.grey.four;

export const primarySkeletonTheme = {
  color: skeletonColor,
};

export const secondarySkeletonTheme = {
  color: skeletonSecondaryColor,
};
